import { defineParams } from '@sveltejs/kit/params';
import { RunPathSchema } from '@papyria/types/paths';

const matchRunPath = (param: string) => RunPathSchema.safeParse(param).success;

export const params = defineParams({
	runPath: (param) => (matchRunPath(param) ? param : undefined)
});
